import {ROLE_ORDER} from '@sollapay/enums';

import type {Role} from '@sollapay/enums';

const RANKED_ROLE_KEYS = new Set<string>(Object.keys(ROLE_ORDER));

/** Custom (phase-2) roles use a generated slug with no entry in `ROLE_ORDER` — `undefined` for those. */
export function getRoleRank(key: string): number | undefined {
  return RANKED_ROLE_KEYS.has(key) ? ROLE_ORDER[key as Role] : undefined;
}
